import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';

import {
  NOTIFICATION_REPOSITORY,
  NotificationRepository
} from '@app/domain/repositories/notification.repository.contract';
import { NotificationStatus } from '@app/entities/enums/notification/notification.enum';
import { Notification } from '@app/entities/models/notifications/notification.model';

import { NotificationUseCases } from './notification.use-cases.contract';

@Injectable({
  providedIn: 'root'
})
export class NotificationUseCasesImpl implements NotificationUseCases {
  #notificationRepository: NotificationRepository = inject(NOTIFICATION_REPOSITORY);
  #notifications: BehaviorSubject<Notification[]> = new BehaviorSubject<Notification[]>([]);
  notifications: Observable<Notification[]> = this.#notifications.asObservable();

  fetchNotifications(lang: string): Observable<Notification[]> {
    return this.#notificationRepository
      .fetchNotifications(lang)
      .pipe(tap((notifications: Notification[]) => this.#notifications.next(notifications)));
  }

  checkAsReadNotification(notification: Notification): Observable<void> {
    return this.#notificationRepository.checkAsReadNotification(notification);
  }

  markNotificationAsRead(notificationId: string) {
    const notificationToUpdate = this.#notifications.getValue().find((n) => n.id === notificationId);

    if (notificationToUpdate) {
      notificationToUpdate.status = NotificationStatus.OPENED;
      this.#notifications.next([...this.#notifications.getValue()]);
    }
  }

  removeFetchedNotification(notificationId: string): void {
    const notifications = this.#notifications.getValue();
    const notificationToRemove = this.#notifications.getValue().findIndex((n) => n.id === notificationId);

    if (notificationToRemove) {
      notifications.splice(notificationToRemove, 1);
      this.#notifications.next([...notifications]);
    }
  }

  getNotificationOfNewPublicationCreated(itemId: string): Notification | undefined {
    return this.#notifications.value.find(
      (notification) =>
        notification.item_id === itemId && notification.status === NotificationStatus.NEW && !notification.section
    );
  }
}
